import React from "react";
import {Box, Stack} from "@mui/material";
import {CurrencyComponent} from "~/components/currency-component/CurrencyComponent";
import {barFraction} from "~/pages/spend-landscape/components/chartHelpers";

/**
 * Spend with a small bar relative to the largest value in its column.
 */
export const SpendBarCell: React.FC<{value: number | null | undefined, max: number}> = ({value, max}) => {
    const v = Number(value ?? 0);
    return <Stack alignItems="flex-end" justifyContent="center" sx={{height: '100%', width: '100%'}} gap={0.25}>
        <span className="tabular"><CurrencyComponent v={v}/></span>
        <Box className="spend-bar" aria-hidden>
            <Box className={'spend-bar-fill' + (v < 0 ? ' negative' : '')}
                 sx={{width: `${barFraction(Math.abs(v), max) * 100}%`}}/>
        </Box>
    </Stack>;
};
